import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
 * Display a localized starting price

 * Takes a currency argument
 * Usage:
 *   price | displayStartingPrice:currency
 * Example:
 *   {{ 2 | displayStartingPrice:'EUR' }}
 *   formats to: à partir de 2,00€
 *
 *   {{ 0 | displayStartingPrice:'USD' }}
 *   formats to: from 0$
*/
@Pipe({ name: 'displayStartingPrice' })
export class DisplayStartingPricePipe implements PipeTransform {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly translateService: TranslateService
  ) {}

  protected getFormattedPrice(value: number, currencyCode: string): string {
    return value
      ? this.currencyPipe.transform(
          value,
          currencyCode,
          'symbol',
          null,
          this.translateService.currentLang
        )
      : this.currencyPipe.transform(
          0,
          currencyCode,
          'symbol',
          '1.0-0',
          this.translateService.currentLang
        );
  }

  public transform(value: number, currencyCode?: string): string {
    const formattedPrice = this.getFormattedPrice(value, currencyCode);

    return this.translateService.instant('price.starting_price', {
      price: formattedPrice,
    });
  }
}
